import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiArrowUpRight } = FiIcons;

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0b1112] px-6 pb-8 pt-16 text-[#f5f0e8] sm:px-10 lg:px-16">
      <div className="mx-auto max-w-[1440px]">
        <div className="grid gap-12 border-b border-[#f5f0e8]/15 pb-14 md:grid-cols-[1.2fr_0.8fr]">
          <div>
            <Link to="/" className="flex items-center gap-3" aria-label="Celestia Fortis home">
              <img
                src="/brand/celestia-fortis-logo.png"
                alt=""
                className="studio-logo-mark"
                aria-hidden="true"
              />
              <span className="font-serif text-2xl tracking-[-0.02em]">Celestia Fortis</span>
            </Link>
            <p className="mt-6 max-w-md text-lg font-light leading-relaxed text-[#a6aaa5]">
              A private studio for the work between categories.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3">
            <div>
              <p className="studio-kicker text-[#d49a55]">Navigate</p>
              <div className="mt-5 flex flex-col gap-3 text-[#c6cbc4]">
                <a href="/#constellation" className="studio-footer-link">The studio</a>
                <a href="/#approach" className="studio-footer-link">Approach</a>
                <a href="/#work" className="studio-footer-link">Current orbits</a>
              </div>
            </div>
            <div>
              <p className="studio-kicker text-[#d49a55]">Connect</p>
              <div className="mt-5 flex flex-col gap-3 text-[#c6cbc4]">
                <Link to="/book" className="studio-footer-link">Book a call</Link>
                <a href="mailto:hello@celestiafortis.com" className="studio-footer-link">Email the studio</a>
                <a href="https://joshuacohen.net" target="_blank" rel="noreferrer" className="studio-footer-link inline-flex items-center gap-1">
                  JoshuaCohen.net
                  <SafeIcon icon={FiArrowUpRight} className="h-3.5 w-3.5" aria-hidden="true" />
                </a>
              </div>
            </div>
            <div>
              <p className="studio-kicker text-[#d49a55]">Legal</p>
              <div className="mt-5 flex flex-col gap-3 text-[#c6cbc4]">
                <Link to="/privacy" className="studio-footer-link">Privacy</Link>
                <Link to="/terms" className="studio-footer-link">Terms</Link>
                <Link to="/disclaimer" className="studio-footer-link">Disclaimer</Link>
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-3 pt-7 text-sm text-[#7f8982] sm:flex-row sm:items-center sm:justify-between">
          <p>© {currentYear} Celestia Fortis. All rights reserved.</p>
          <p className="studio-meta">Built for a longer horizon.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
